var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exit_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".exit_svg__st0{fill-rule:evenodd;clip-rule:evenodd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "exit_svg__st0",
    d: "M14.2 4.8c.7-.5 1.6-.4 2.1.3L20 10l-3.7 4.9c-.5.7-1.4.8-2.1.3-.7-.5-.8-1.4-.3-2.1l1.2-1.6H7.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h7.6l-1.2-1.6c-.5-.7-.3-1.6.3-2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "exit_svg__st0",
    d: "M1 4.5C1 2.6 2.6 1 4.5 1h4C10.4 1 12 2.6 12 4.5v1c0 .8-.7 1.5-1.5 1.5S9 6.3 9 5.5v-1c0-.3-.2-.5-.5-.5h-4c-.3 0-.5.2-.5.5v11c0 .3.2.5.5.5h4c.3 0 .5-.2.5-.5v-1c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v1c0 1.9-1.6 3.5-3.5 3.5h-4C2.6 19 1 17.4 1 15.5v-11z"
  })));
};
export default SvgExit;